import Swiper from "swiper";
import {Tracking} from "../../tracking/tracking";

export class GenericSwiper {
  constructor(swiperDivList: NodeListOf<HTMLElement>) {
    Array.from<HTMLElement>(swiperDivList).forEach((swiperDiv) => {
      const _ = new Swiper(swiperDiv, params);
      _.loaded = true;
    });
  }
}

const params = {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  on: {
    slideChange,
  },
  pagination: {
    clickable: true,
    el: ".swiper-pagination",
  },
  simulateTouch: false,
};

function slideChange() {
  if (this.loaded) {
    Tracking.sendEvent("GenericSwiper.Swiped");
  }
}
